var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDeleteTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 14v1H2V2h13v7h-1V7h-3v2h-1V7H7v3h2v1H7v3zm5-8h-3V3h3zM7 3h3v3H7zM3 3v3h3V3zm0 4v3h3V7zm0 4v3h3v-3zm11.292-1 .708.708-1.793 1.792L15 14.292l-.708.708-1.792-1.793L10.708 15 10 14.292l1.793-1.792L10 10.708l.708-.708 1.792 1.793z",
  clipRule: "evenodd"
})));
export default SvgDeleteTable;